/* eslint-disable @typescript-eslint/no-redeclare */
/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { Bizo, autoclass } from './base'
import type {
  GlobalNavLinks as GlobalNavLinksType,
  RawGlobalNavLinks,
} from './globalNavLinks.types'

export const GlobalNavLinks = autoclass<GlobalNavLinksType, RawGlobalNavLinks>(
  'GlobalNavLinks',
  class GlobalNavLinks extends Bizo<GlobalNavLinksType, RawGlobalNavLinks> {},
  {
    urls: 'urls',
    propertyType: 'property_type',
  }
)

export type GlobalNavLinks = GlobalNavLinksType
